import * as React from 'react';

import * as styles from './GalleryPreloader.css';

export interface IGalleryPreloaderProps {
  imageUrl: string;
}

export function GalleryPreloader({ imageUrl }: IGalleryPreloaderProps) {
  return (
    <div className={styles['container']}>
      <img className={styles['image']} src={imageUrl} alt="" />
    </div>
  );
}
